import {Component, Input, OnInit} from '@angular/core';
import {PreorderType} from '../../../smoothr-web-app-core/enums/PreorderType';
import moment from 'moment';
import {TranslateService} from '@ngx-translate/core';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import {AlertController, ModalController} from '@ionic/angular';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import RepositoryInterface from '../../../smoothr-web-app-core/directives/repository-directive';
import {OrderListAction} from '../../enums/OrderListAction';
import {AppComponent} from '../../app.component';
import {ModalInfoComponent} from '../modal-info/modal-info.component';
import {CheckoutModalComponent} from '../checkout-modal/checkout-modal.component';
import {OrderUtils} from '../../../smoothr-web-app-core/utils/order-utils';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleOption from '../../../smoothr-web-app-core/models/ArticleOption';
import {MenuPage} from '../../pages/menu/menu.page';
import Order from '../../../smoothr-web-app-core/models/Order';
import {PromoCodeType} from '../../../smoothr-web-app-core/models/PromoCodeType';
import {defaultsToArticleOptionForOrder, numberToCurrency, sleep} from '../../../smoothr-web-app-core/utils/utils';
import {AnalyticsService} from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import {NoteArticleModalComponent} from '../note-article-modal/note-article-modal.component';
import {NavigationService, NAVIGATIONURLS} from 'src/app/services/navigation.service';
import {Registration} from 'src/app/pages/sign-up/sign-up.page';
import {DisplayIdentifier} from 'src/smoothr-web-app-core/enums/DisplayIdentifier';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import {AlertInfoModalComponent} from '../alert-info-modal/alert-info-modal.component';

enum EditItemsInBasketEnum {
	ARTICLESWITHSUBSCRIPTION = 'orderedSubscriptionArticles',
	ORDEREDARTICLE = 'orderedArticles'
}

@Component({
	selector: 'app-order-content',
	templateUrl: './order-content.component.html',
	styleUrls: ['order-content.component.scss']
})
export class OrderContentComponent extends RepositoryInterface implements OnInit {
	moment = moment;

	isValid = false;
	loading = false;
	editItemsInBasketEnum = EditItemsInBasketEnum;
	ou = OrderUtils;
	pt = PreorderType;
	differenceToMvo: number;
	@Input()
	fromMenu = false;
	promoError: string;
	tip = 0;
	vitalCode = '';
	numberToCurrency = numberToCurrency;
	public culteryForm = false;
	public userSubscription = this.repository.mapUserSubscriptions(this.repository?._customerAuth?.subscription);
	constructor(
		private translate: TranslateService,
		protected repository: RepositoryService,
		private modalCtrl: ModalController,
		private snackbarCtrl: MatSnackBar,
		private router: Router,
		private route: ActivatedRoute,
		private alertCtrl: AlertController,
		private analytics: AnalyticsService,
		private navigationService: NavigationService
	) {
		super(repository);
		this.validate();
	}

	get hasArticles(): boolean {
		return (
			!!this.order &&
			(this.order.orderedArticles.length > 0 ||
				this.order.orderedSubscriptionArticles.length > 0 ||
				this.order.subscriptions.length > 0)
		);
	}

	ngOnInit() {
		super.ngOnInit();
		this.analytics.openOrderContent();
		this.firstStartCultury();
		this.showArticlesWhichHaveDiscount(this.order);
	}

	onVenue() {
		super.onVenue();
		this.validate();
	}

	onOrder() {
		super.onOrder();
		if (this.order && this.order.orderedArticles && this.order.orderedArticles.length > 0) {
			this.analytics.orderHasProducts();
		}
		this.validate();
	}

	async onAction(index: number, event: OrderListAction, editItemEnum: EditItemsInBasketEnum) {
		const changeItem = this.order[editItemEnum];
		switch (event) {
			case OrderListAction.add:
				if (editItemEnum === EditItemsInBasketEnum.ARTICLESWITHSUBSCRIPTION) {
					if (this.increaseArticleQunatity(changeItem[index])) {
						changeItem[index].quantity += 1;
					}
					return;
				}
				changeItem[index].quantity += 1;
				break;
			case OrderListAction.delete:
				if (OrderUtils.isBogoOrFreeArticlePromo(this.order) && this.order.promoCode.type === PromoCodeType.BOGO) {
					const bogoArticleIndex = changeItem.findIndex(ag => ag.isPromo);
					const bogoArticle = changeItem[bogoArticleIndex];
					const matchingBogoArticleIndices = changeItem
						.map((ag, agIndex) => {
							return ag.article._id === bogoArticle.article._id &&
								!ag.isPromo &&
								OrderUtils.bogoPrice(ag, this.order.type, this.order.preorder.type) ===
									OrderUtils.bogoPrice(bogoArticle, this.order.type, this.order.preorder.type)
								? agIndex
								: -1;
						})
						.filter(agIndex => agIndex !== -1);
					if (matchingBogoArticleIndices.find(bogoIndex => bogoIndex === index) !== undefined) {
						// article that should be removed is a possible parent of promoCode article
						if (matchingBogoArticleIndices.length === 1) {
							// only that article is possible parent of promoCode. If this article is removed the PromoCode and PromoArticle
							// should also be removed. Ask user.
							const bogoAlert = await this.alertCtrl.create({
								header: this.translate.instant('remove_bogo_alert.header'),
								message: this.translate.instant('remove_bogo_alert.message'),
								buttons: [
									{
										text: this.translate.instant('remove_bogo_alert.button_remove'),
										handler: () => {
											changeItem[bogoArticleIndex].isPromo = false;
											this.order.promoCode = null;
											changeItem.splice(index, 1);
											bogoAlert.dismiss();
										}
									},
									{
										text: this.translate.instant('remove_bogo_alert.button_keep'),
										handler: () => {
											bogoAlert.dismiss();
										}
									}
								]
							});
							await bogoAlert.present();
							await bogoAlert.onDidDismiss();
							break;
						}
					}
				}
				this.checkCultery();
				changeItem.splice(index, 1);
				break;
			case OrderListAction.note:
				this.noteArticle(index);
				break;
			case OrderListAction.edit:
				const modal = await this.modalCtrl.create({
					cssClass: AppComponent.largeScreen ? 'item-modal large-modal' : 'item-modal',
					component: ModalInfoComponent,
					componentProps: {
						// copy article group
						articleGroup: JSON.parse(JSON.stringify(changeItem[index])),
						recommend: false
					},
					showBackdrop: true,
					backdropDismiss: true
				});
				await modal.present();
				const response = await modal.onDidDismiss();
				if (response.data && response.data.articleGroup) {
					const promoAgIndex = changeItem.findIndex(oa => oa.isPromo);
					if (
						OrderUtils.isBogoOrFreeArticlePromo(this.order) &&
						this.order.promoCode.type === PromoCodeType.BOGO &&
						changeItem[index].article._id === changeItem[promoAgIndex].article._id &&
						OrderUtils.bogoPrice(response.data.articleGroup, this.order.type, this.order.preorder.type) <
							OrderUtils.bogoPrice(changeItem[promoAgIndex], this.order.type, this.order.preorder.type)
					) {
						changeItem[promoAgIndex].isPromo = false;
						const newPromoAg = JSON.parse(JSON.stringify(response.data.articleGroup));
						newPromoAg.isPromo = true;
						changeItem.push(newPromoAg);
					}
					changeItem[index] = response.data.articleGroup;
					this.repository.order.emit(this.order);
				}
				break;
			case OrderListAction.remove:
				if (changeItem[index].quantity > 1) {
					changeItem[index].quantity -= 1;
				} else {
					await this.onAction(index, OrderListAction.delete, editItemEnum);
					return;
				}
				break;
		}
		this.repository.order.emit(this.order);
	}
	onActionSubscriptions(index: number) {
		this.order.subscriptions.splice(index, 1);
		this.repository.order.emit(this.order);
	}

	async openCheckoutModal() {
		this.validate();
		if (!this.isValid || this.loading) {
			return;
		}
		const foundVytalArticle = this.order.orderedArticles.find(
			it => !!it.groups.find(group => !!group.article.tags.find(tag => tag?.identifier === 'vytal'))
		);
		if (!this.order.note && foundVytalArticle) {
			await AlertInfoModalComponent.show(
				this.modalCtrl,
				'Please, enter vytal code',
				'You select option vytal, u need to input vytal Code',
				'',
				this.translate.instant('checkout_modal.cancel')
			);
			return;
		}
		this.loading = true;
		const result = await CheckoutModalComponent.show(this.modalCtrl, this.analytics, this.order, this.tip);
		if (result.data === undefined) {
			this.loading = false;
			return;
		}
		if (result.data?.changeRoute) {
			await this.navigationService.navigateToUrlWithParams(NAVIGATIONURLS.signUp(), {auth: Registration.SIGN_IN});
			return;
		}
		this.order.orderAt = result.data.orderAt;
		this.order.preorder = result.data.preorder;
		this.repository.order.emit(this.order);
		const copy = JSON.parse(JSON.stringify(this.order)) as Order;

		try {
			await this.repository.createOrderWithPayment(
				this.modalCtrl,
				this.translate,
				copy,
				this.tip,
				loading => (this.loading = loading),
				this.snackbarCtrl,
				this.order.tableNumber !== 'preorder_table'
			);
		} catch (e) {
			console.log(JSON.parse(JSON.stringify(e)));
		}
	}

	validate() {
		if (!this.order || !this.venue || !this.order.preorder) {
			this.isValid = false;
			return;
		}
		const result = OrderUtils.validateOrder(this.venue, this.order);

		this.differenceToMvo = result.movDifference;
		this.isValid = true;
	}

	totalPrice() {
		const orderCopy = JSON.parse(JSON.stringify(this.order));
		const orderCopyWithSub = this.repository.changeOrderWithSubscriptions(
			orderCopy,
			(this.repository?._customerAuth?.subscription ?? []).map(it => it.subscription)
		);
		return numberToCurrency(
			OrderUtils.orderTotalPrice(
				orderCopyWithSub,
				true,
				true,
				this.repository.mapUserSubscriptions(this.repository?._customerAuth?.subscription)
			),
			this.order.currency
		);
	}

	replace(index: number, article: Article, options: ArticleOption[]) {
		this.order.orderedArticles[index].quantity = 1;
		this.order.orderedArticles[index].article = article;
		this.order.orderedArticles[index].groups = options;
	}

	onPromoApplied(order: Order) {
		this.promoError = null;
		this.repository.order.emit(order);
	}

	onDeletePromo(order: Order) {
		this.promoError = null;
		this.repository.order.emit(order);
	}

	onPromoCodeError(error: string) {
		if (!error) {
			// error just resetting error no error happened
			return;
		}
		// Promo error
		this.snackbarCtrl.open(error, null, {duration: 2000});
		this.repository.order.emit(OrderUtils.removePromo(this.order));
		this.promoError = error;
	}

	async backToMenu() {
		await this.navigationService.menu();
	}

	async noteArticle(index: number) {
		const modal = await this.modalCtrl.create({
			cssClass: 'short-info-modal auto-height',
			component: NoteArticleModalComponent,
			componentProps: {
				// copy article group
				articleGroup: JSON.parse(JSON.stringify(this.order.orderedArticles[index])),
				recommend: false
			},
			showBackdrop: true,
			backdropDismiss: true
		});
		await modal.present();
		const response = await modal.onDidDismiss();
		if (response?.data) {
			this.order.orderedArticles[index].note = response?.data;
		}
	}
	changeCulturyForm() {
		if (this.culteryForm) {
			if (
				this.order.orderedArticles.length > 0 &&
				!this.order.orderedArticles.find(
					it => it.article.tags.length > 0 && it.article.tags.filter(tag => tag.identifier === 'cutlery').length > 0
				)
			) {
				const articleCultery = this.venue.articleCategories
					.map(it => {
						const hasArticle = it.articles.filter(it => it.tags.filter(tag => tag.identifier === 'cutlery').length > 0);
						if (hasArticle.length > 0) {
							return hasArticle[0];
						}
						return null;
					})
					.filter(it => !!it)[0];
				if (articleCultery) {
					const articleGroupPfand = new ArticleGroup();
					articleGroupPfand.article = articleCultery;
					articleGroupPfand.quantity = 1;
					articleGroupPfand.groups = defaultsToArticleOptionForOrder(
						articleCultery,
						[],
						articleCultery.defaults,
						this.order
					);
					this.order.orderedArticles.push(articleGroupPfand);
					this.repository.order.emit(this.order);
				}
			}
		} else {
			const foundIndexCultery = this.order.orderedArticles.findIndex(
				it => it.article.tags.length > 0 && it.article.tags.filter(tag => tag.identifier === 'cutlery').length > 0
			);
			if (foundIndexCultery >= 0) {
				this.order.orderedArticles.splice(foundIndexCultery, 1);
				this.repository.order.emit(this.order);
			}
		}
	}
	async firstStartCultury() {
		if (
			this.order.orderedArticles.find(
				it => it.article.tags.length > 0 && it.article.tags.filter(tag => tag.identifier === 'cutlery').length > 0
			) &&
			!this.culteryForm
		) {
			this.culteryForm = true;
		}
	}
	async checkCultery() {
		sleep(300);
		if (
			this.order.orderedArticles.find(
				it => it.article.tags.length > 0 && it.article.tags.filter(tag => tag.identifier === 'cutlery').length > 0
			) &&
			this.culteryForm
		) {
			this.culteryForm = false;
		}
	}
	setVitalCode(value: string) {
		this.vitalCode = value;
	}
	increaseArticleQunatity(articleGroup: ArticleGroup) {
		//have subscription
		const subscrtionOfSelectedArticle = this.userSubscription.find(it =>
			it.articles.find(it => it === articleGroup.article._id)
		);
		// to chekc how many articles in basket in this subscription
		const articlesWhichAlredyInSubscription = this.order.orderedSubscriptionArticles.filter(it =>
			subscrtionOfSelectedArticle.articles.includes(it.article._id)
		);
		if (
			subscrtionOfSelectedArticle.maxArticlesPerOrder > articlesWhichAlredyInSubscription.length &&
			(subscrtionOfSelectedArticle.maxPricePerOrder
				? subscrtionOfSelectedArticle.maxPricePerOrder >
				  OrderUtils.articleGroupsTotalPrice(
						articlesWhichAlredyInSubscription,
						this.order.type,
						this.order.preorder.type
				  ) +
						OrderUtils.totalPrice(articleGroup, this.order.type, this.order.preorder.type)
				: true)
		) {
			return true;
		} else {
			return false;
		}
	}
	showArticlesWhichHaveDiscount(order: Order) {
		const orderArticles = JSON.parse(JSON.stringify(order.orderedArticles)) as ArticleGroup[];
		const groupByToMap = <T, Q>(array: T[], predicate: (value: T, index: number, array: T[]) => Q) =>
			array.reduce((map, value, index, array) => {
				const key = predicate(value, index, array);
				map.get(key)?.push(value) ?? map.set(key, [value]);
				return map;
			}, new Map<Q, T[]>());
		// take every article how many times how many quantity i have
		const mappedByQuantity = orderArticles.reduce((acc, articleGroup) => {
			acc.push(...Array(articleGroup.quantity).fill({...articleGroup, quantity: 1}));
			return acc;
		}, [] as ArticleGroup[]);
		// GROUP articles with by sub ID
		const groupArray = groupByToMap(mappedByQuantity, v => v.subscription);
		const arrayOfDiscountArticles = [] as ArticleGroup[];
		this.userSubscription.forEach(it => {
			if (groupArray.has(it._id)) {
				const valueOfGroup = groupArray.get(it._id);
				const maxQunatityOfArticles = it.maxArticlesPerOrder;
				//check if i need to add items
				if (!it.maxPricePerOrder && maxQunatityOfArticles > 0) {
					arrayOfDiscountArticles.push(...valueOfGroup.splice(0, maxQunatityOfArticles));
					return;
				}
				if (it.maxPricePerOrder > 0 && maxQunatityOfArticles > 0) {
					let price = 0;
					let quantity = 0;
					valueOfGroup.forEach(articleGroup => {
						if (
							OrderUtils.totalPrice(articleGroup, this.order.type, this.order.preorder.type) + price <
								it.maxPricePerOrder &&
							quantity < it.maxArticlesPerOrder
						) {
							arrayOfDiscountArticles.push(articleGroup);
							price = price + OrderUtils.totalPrice(articleGroup, this.order.type, this.order.preorder.type);
							++quantity;
						}
					});
				}
			}
		});
		const finalArray = [] as ArticleGroup[];

		arrayOfDiscountArticles.forEach(it => {
			const foundArticleIndex = finalArray.findIndex(art => art.article._id === it.article._id);
			if (foundArticleIndex < 0) {
				finalArray.push(it);
			} else {
				finalArray[foundArticleIndex].quantity = ++finalArray[foundArticleIndex].quantity;
			}
		});
		return finalArray;
	}
	onAddVytalCode(value: string) {
		this.order.note = value;
		this.repository.order.emit(this.order);
	}
}
